export function mainSliderPhotos() {
    let $mainSliderAnimationHolder = $(".main-slider-animation-holder");
    let $mainSliderAnimation = $(".main-slider-animation");
    let $mainSlider = $(".main-slider");
    $mainSlider.slick({
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    // slidesToShow: 2.2,
                    variableWidth: true,
                    slidesToScroll: 1
                }
            }
        ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $mainSliderAnimation.slick('slickGoTo', nextSlide);
    });
    $mainSliderAnimation.slick({
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    });

    $mainSlider.find(".image-zoom").on("click", function () {
        let $this = $(this);
        if ($this.parents(".slick-current").length) {
            $mainSliderAnimationHolder.addClass("show active");
        } else {
            let index = $this.parents(".slick-slide").data("slick-index");
            $mainSlider.slick('slickGoTo', index);
            setTimeout(function () {
                $mainSliderAnimationHolder.addClass("show active");
            }, 500);
        }
    });
    $mainSliderAnimation.find(".image-zoom").on("click", function () {
        $mainSliderAnimationHolder.removeClass("active");
        setTimeout(function () {
            $mainSliderAnimationHolder.removeClass("show");
        }, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mainSliderPhotos.js